import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
 
  sectionContainer: {
    width: '100%',
    minHeight: '480px',
    backgroundColor: theme.palette.background.ecosystem,
    color: theme.palette.text.ecosystemText,
    padding: theme.spacing(8, 3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: '"Hanken Grotesk", sans-serif',
    transition: 'background-color 0.3s ease, color 0.3s ease',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(10, 8),
    },
  },
 

  sectionHeader: {
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.25em',
    textTransform: 'uppercase',
    color: theme.palette.text.ecosystemHeader,
    textAlign: 'center',
    marginBottom: theme.spacing(6),
  },


  metricsContainer: {
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(8),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      marginBottom: theme.spacing(12),
    },
  },

  
  metricBox: {
    flex: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3, 2),
    cursor: 'pointer',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)',
    },
    
    [theme.breakpoints.up('md')]: {
      borderRight: `1px solid ${
        theme.palette.text.ecosysteMetricBox
      }`,
      '&:last-child': {
        borderRight: 'none',
      },
    },
  },


  metricValue: {
    fontSize: '56px',
    fontWeight: 800,
    lineHeight: 1,
    letterSpacing: '-0.03em',
    color: theme.palette.text.ecosysteMetric,
    marginBottom: theme.spacing(1),
    transition: 'color 0.3s ease',
    [theme.breakpoints.up('md')]: {
      fontSize: '80px',
    },
    '$metricBox:hover &': {
      color: theme.palette.text.ecosysteMetricHover,
    },
  },


  metricLabel: {
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
      color: theme.palette.text.ecosysteMetricLabel,
  },


  partnersContainer: {
    width: '100%',
    maxWidth: '1000px',
    textAlign: 'center',
  },

 
  partnersGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(8),
    },
  },


  partnerItem: {
    fontSize: '18px',
    fontWeight: 700,
    letterSpacing: '-0.01em',
    color: theme.palette.text.ecosystemPartnerItem,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'color 0.2s ease, transform 0.2s ease',
    '&:hover': {
    color: theme.palette.text.ecosystemPartnerItemHover,
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '24px',
    },
      animation: '$fadeUp 0.5s ease both',

  },
  '@keyframes fadeUp': {
  from: { opacity: 0, transform: 'translateY(20px)' },
  to:   { opacity: 1, transform: 'translateY(0)' },
},

}));

export default useStyles;